import { c as _c } from "react/compiler-runtime";
import { ListLoader, ListOptionsProps, ListOptionsWrapper, getEmptyValue, getPanelHeight, renderOption } from '@systemeio/ui';
import { Fragment, useState } from 'react';
import { FormSelectDataWithGroupType } from 'shared/components/form-select/form-select-with-groups';
import { twMerge } from 'tailwind-merge';
export interface ListOptionsWithGroupsProps extends Omit<ListOptionsProps, 'data'> {
  groups: {
    id: string;
    caption: string;
  }[];
  data: FormSelectDataWithGroupType[] | undefined;
}
export function ListOptionsWithGroups(t0) {
  const $ = _c(14);
  const {
    optionsClassName,
    data,
    loaderWrapperClassName,
    loaderClassName,
    groups,
    asOptions,
    asOption,
    ...optionProps
  } = t0;
  const dataByGroup = (data ?? []).reduce(_temp, {} as Record<string, FormSelectDataWithGroupType[]>);
  const mapData = Object.entries(dataByGroup);
  const [listRef, setListRef] = useState(null);
  let t1;
  if ($[0] !== data || $[1] !== listRef) {
    t1 = getPanelHeight(listRef, data);
    $[0] = data;
    $[1] = listRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const height = t1;
  const T0 = ListOptionsWrapper;
  let t2;
  if ($[3] !== height) {
    t2 = {
      height
    };
    $[3] = height;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== optionsClassName) {
    t3 = twMerge("h-fit", optionsClassName);
    $[5] = optionsClassName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = data === undefined ? <ListLoader loaderWrapperClassName={loaderWrapperClassName} loaderClassName={loaderClassName} /> : <>{mapData.length > 0 ? mapData.map(t5 => {
      const [key, value] = t5;
      const groupCaption = groups.find(group => group.id === key)?.caption;
      return <Fragment key={key}><div role="option" className="text-text-primary border-text-secondary/30 w-full border-b px-4 py-1.5 font-bold">{groupCaption}</div>{value.map(item_0 => renderOption({
          item: item_0,
          as: asOption,
          ...optionProps
        }))}</Fragment>;
    }) : renderOption({
      item: getEmptyValue(),
      as: asOption,
      ...optionProps
    })}</>;
  let t6;
  if ($[7] !== T0 || $[8] !== asOptions || $[9] !== setListRef || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t6 = <T0 ref={setListRef} style={t2} as={asOptions} optionsClassName={t3}>{t4}</T0>;
    $[7] = T0;
    $[8] = asOptions;
    $[9] = setListRef;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(acc, item) {
  return {
    ...acc,
    [item.group]: acc[item.group] ? [...acc[item.group], item] : [item]
  };
}